<template>
	<div class="p-10">
		<h1>{{ $t('integrations.title') }}</h1>
		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.exact') }}</span>
			</div>
			<el-alert
				type="info"
				:title="$t('integrations.exact_division_info')"
				:closable="false"
				show-icon
				style="margin-bottom: 20px;">
			</el-alert>
			<el-form ref="connectExactForm" :model="exact.form" label-width="200px" :disabled="!hasPermission">

				<el-form-item :label="$t('integrations.custom_app')">
					<el-checkbox v-model="exact.form.custom"></el-checkbox>
				</el-form-item >
				<template v-if="exact.form.custom">
					<el-form-item :label="$t('integrations.client_id')">
						<el-input v-model="exact.form.clientId" placeholder=""/>
					</el-form-item >

					<el-form-item :label="$t('integrations.client_secret')">
						<el-input v-model="exact.form.clientSecret" placeholder="" type="password" />
					</el-form-item >

					<el-form-item :label="$t('integrations.webhook_secret')">
						<el-input v-model="exact.form.webhookSecret" placeholder="" type="password" />
					</el-form-item >

					<el-form-item :label="$t('integrations.redirect_uri')">
						<el-input v-model="exact.form.redirectUri" placeholder="" />
					</el-form-item >
				</template>

				<el-form-item :label="$t('integrations.participant.name')">
					<el-input
						v-model="participantName"
						placeholder=""
						:disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="exact.form.legalEntity" clearable style="width:300px" size="mini">
						<el-option v-for="legalEntity in localLegalEntities" :key="legalEntity.reference" :value="legalEntity.reference" :label="legalEntity.registration_name">
							{{ legalEntity.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" :disabled="exact.loading || (exact.form.legalEntity === null || exact.form.legalEntity === '') || !hasPermission" @click="connectExact">
						{{ $t('integrations.connect_exact') }}
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.ponto') }}</span>
			</div>
			<el-form ref="connectPontoForm" :model="ponto.form" label-width="200px" :disabled="!hasPermission">
				<el-form-item :label="$t('integrations.participant.name')">
					<el-input
						v-model="participantName"
						placeholder=""
						:disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="ponto.form.legalEntity" clearable style="width:300px" size="mini" >
						<el-option v-for="legalEntity in localLegalEntities" :key="legalEntity.reference" :value="legalEntity.reference" :label="legalEntity.registration_name">
							{{ legalEntity.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="mini" :disabled="ponto.loading || (ponto.form.legalEntity === null || ponto.form.legalEntity === '')" @click="connectPonto">
						{{ $t('integrations.connect_ponto') }}
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.teamleader') }}</span>
			</div>
			<el-form ref="connectTeamleaderForm" :model="teamleader.form" label-width="200px" :disabled="!hasPermission">
				<el-form-item :label="$t('integrations.participant.name')">
					<el-input
						v-model="participantName"
						placeholder=""
						:disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="teamleader.form.legalEntity" clearable style="width:300px" size="mini">
						<el-option v-for="legalEntity in localLegalEntities" :key="legalEntity.reference" :value="legalEntity.reference" :label="legalEntity.registration_name">
							{{ legalEntity.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="mini" :disabled="teamleader.loading || (teamleader.form.legalEntity === null || teamleader.form.legalEntity === '')" @click="connectTeamleader">
						{{ $t('integrations.connect_teamleader') }}
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.octopus') }}</span>
			</div>
			<el-form ref="connectOctopusForm" :model="octopus.form" label-width="200px" :disabled="!hasPermission">
				<el-form-item :label="$t('integrations.participant.name')">
					<el-input
						v-model="participantName"
						placeholder=""
						:disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="octopus.form.legalEntity" clearable style="width:300px" size="mini">
						<el-option v-for="legalEntity in localLegalEntities" :key="legalEntity.reference" :value="legalEntity.reference" :label="legalEntity.registration_name">
							{{ legalEntity.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" :disabled="octopus.loading || (octopus.form.legalEntity === null || octopus.form.legalEntity === '')" @click="connectOctopus">
						{{ $t('integrations.connect_octopus') }}
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.gdw') }}</span>
			</div>
			<el-alert
				v-if="!hasGdwGetTokenPermission"
				type="warning"
				:title="$t('notAllowed')"
				:closable="false"
				show-icon
				style="margin-bottom: 20px;">
			</el-alert>
			<el-form ref="connectGdwForm" :model="gdw.form" label-width="200px" :disabled="!hasGdwGetTokenPermission">
				<el-form-item :label="$t('integrations.participant.name')">
					<el-input v-model="participantName" style="width:300px" size="mini" disabled />
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="gdw.form.legalEntity" style="width:300px" size="mini" :loading="gdw.loadingCredentials">
						<el-option
							v-for="le in filteredGdwLegalEntities"
							:key="le.reference"
							:value="le.reference"
							:label="le.registration_name"
						>
							{{ le.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('integrations.party_id')">
					<el-input v-model="gdw.form.partyId" placeholder="" style="width:100px" maxlength="6" size="mini" :disabled="gdw.loadingCredentials">
						<i v-if="gdw.loadingCredentials" slot="suffix" class="el-input__icon el-icon-loading"></i>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('integrations.token')">
					<el-input
						v-model="gdw.form.token"
						placeholder=""
						style="width:400px"
						maxlength="60"
						size="mini"
						:type="gdw.showToken ? 'text' : 'password'"
						:class="{ 'is-error': gdw.form.token && !isGdwTokenValid }"
						:disabled="gdw.loadingCredentials">
						<i v-if="gdw.loadingCredentials" slot="prefix" class="el-input__icon el-icon-loading"></i>
						<el-button
							slot="append"
							:icon="gdw.showToken ? 'el-icon-close' : 'el-icon-view'"
							:disabled="gdw.loadingCredentials"
							@click="gdw.showToken = !gdw.showToken">
							{{ gdw.showToken ? $t('integrations.hide_token') : $t('integrations.show_token') }}
						</el-button>
					</el-input>
					<div v-if="gdw.form.token && !isGdwTokenValid" style="color: #F56C6C; font-size: 12px; line-height: 1; padding-top: 4px;">
						{{ $t('integrations.token_format_error') }}
					</div>
					<div v-else style="color: #909399; font-size: 12px; line-height: 1; padding-top: 4px;">
						{{ $t('integrations.token_format_hint') }}
					</div>
				</el-form-item>
				<el-form-item v-if="gdw.status">
					<el-alert
						:type="gdw.status.type"
						:title="gdw.status.message"
						:closable="true"
						show-icon
						@close="gdw.status = null">
					</el-alert>
				</el-form-item>
				<el-form-item>
					<el-tooltip :content="!hasGdwSaveTokenPermission ? $t('notAllowed') : ''" placement="top" :disabled="hasGdwSaveTokenPermission">
						<el-button type="primary" size="mini" :disabled="gdw.loading || !hasGdwSaveTokenPermission || !gdw.form.legalEntity || !gdw.form.partyId || !isGdwTokenValid" @click="saveGdw">
							{{ $t('integrations.save_gdw') }}
						</el-button>
					</el-tooltip>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card>
			<div slot="header" class="clearfix">
				<span>{{ $t('integrations.twikey') }}</span>
			</div>
			<el-alert
				v-if="!hasTwikeyGetApiKeyPermission"
				type="warning"
				:title="$t('notAllowed')"
				:closable="false"
				show-icon
				style="margin-bottom: 20px;">
			</el-alert>
			<el-form ref="connectTwikeyForm" :model="twikey.form" label-width="200px" :disabled="!hasTwikeyGetApiKeyPermission">
				<el-form-item :label="$t('integrations.participant.name')">
					<el-input v-model="participantName" style="width:300px" size="mini" disabled />
				</el-form-item>
				<el-form-item :label="$t('legalEntity')">
					<el-select v-model="twikey.form.legalEntity" style="width:300px" size="mini" :loading="twikey.loadingCredentials">
						<el-option
							v-for="le in filteredTwikeyLegalEntities"
							:key="le.reference"
							:value="le.reference"
							:label="le.registration_name"
						>
							{{ le.registration_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('integrations.api_url')">
					<el-input v-model="twikey.form.apiUrl" placeholder="" style="width:400px" size="mini" :disabled="twikey.loadingCredentials">
						<i v-if="twikey.loadingCredentials" slot="suffix" class="el-input__icon el-icon-loading"></i>
					</el-input>
					<div v-if="twikey.form.apiUrl && !isTwikeyApiUrlValid" class="el-form-item__error" style="position: static; margin-top: 4px;">
						{{ $t('integrations.invalid_twikey_api_url') }}
					</div>
				</el-form-item>
				<el-form-item :label="$t('integrations.api_key')">
					<el-input
						v-model="twikey.form.apiKey"
						placeholder=""
						style="width:400px"
						size="mini"
						:type="twikey.showApiKey ? 'text' : 'password'"
						:disabled="twikey.loadingCredentials">
						<i v-if="twikey.loadingCredentials" slot="prefix" class="el-input__icon el-icon-loading"></i>
						<el-button
							slot="append"
							:icon="twikey.showApiKey ? 'el-icon-close' : 'el-icon-view'"
							:disabled="twikey.loadingCredentials"
							@click="twikey.showApiKey = !twikey.showApiKey">
							{{ twikey.showApiKey ? $t('integrations.hide_api_key') : $t('integrations.show_api_key') }}
						</el-button>
					</el-input>
				</el-form-item>
				<el-form-item v-if="twikey.status">
					<el-alert
						:type="twikey.status.type"
						:title="twikey.status.message"
						:closable="true"
						show-icon
						@close="twikey.status = null">
					</el-alert>
				</el-form-item>
				<el-form-item>
					<el-tooltip :content="!hasTwikeySaveApiKeyPermission ? $t('notAllowed') : ''" placement="top" :disabled="hasTwikeySaveApiKeyPermission">
						<el-button type="primary" size="mini" :disabled="twikey.loading || !hasTwikeySaveApiKeyPermission || !twikey.form.legalEntity || !twikey.form.apiUrl || !twikey.form.apiKey || !isTwikeyApiUrlValid" @click="saveTwikey">
							{{ $t('integrations.save_twikey') }}
						</el-button>
					</el-tooltip>
				</el-form-item>
			</el-form>
		</el-card>

	</div>
</template>

<script>
import { GET_PARTICIPANT_DETAILS } from '@/gql';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import i18n from '@/i18n';
import { hasLicenseAndPermission } from '@/helpers/permission-helper';

export default {
	data() {
		return {
			participantName: undefined,
			localLegalEntities: [],
			exact: {
				loading: false,
				form: {
					custom: false,
					clientId: null,
					clientSecret: null,
					webhookSecret: null,
					redirectUri: null,
					legalEntity: null
				}
			},
			ponto: {
				loading: false,
				form: {
					legalEntity: null
				}
			},
			teamleader: {
				loading: false,
				form: {
					legalEntity: null
				}
			},
			octopus: {
				loading: false,
				form: {
					legalEntity: null
				}
			},
			gdw: {
				loading: false,
				loadingCredentials: false,
				showToken: false,
				status: null, // { type: 'success' | 'error', message: '' }
				form: {
					legalEntity: null,
					partyId: null,
					token: null
				}
			},
			twikey: {
				loading: false,
				loadingCredentials: false,
				showApiKey: false,
				status: null, // { type: 'success' | 'error', message: '' }
				form: {
					legalEntity: null,
					apiUrl: null,
					apiKey: null
				}
			}
		};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore', 'selectedLegalEntityStore']),
		hasPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'CORE',
				'UI_EDIT_INTEGRATIONS'
			);
		},
		hasGdwGetTokenPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'CORE',
				'INTEGRATION_GDW_DWB_GET_TOKEN'
			);
		},
		hasGdwSaveTokenPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'CORE',
				'INTEGRATION_GDW_DWB_SAVE_TOKEN'
			);
		},
		hasTwikeyGetApiKeyPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'TWIKEY',
				'INTEGRATION_TWIKEY_GET_API_KEY'
			);
		},
		hasTwikeySaveApiKeyPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'TWIKEY',
				'INTEGRATION_TWIKEY_SAVE_API_KEY'
			);
		},
		isGdwTokenValid() {
			if (!this.gdw.form.token) return false;
			// Validate format: New format: XX|<48 chars> OR Old format: <60 chars>
			const newTokenPattern = /^\d{2}\|[A-Za-z0-9]{48}$/;
			const oldTokenPattern = /^[A-Za-z0-9]{60}$/;
			return newTokenPattern.test(this.gdw.form.token) || oldTokenPattern.test(this.gdw.form.token);
		},
		isTwikeyApiUrlValid() {
			if (!this.twikey.form.apiUrl) return false;
			try {
				const url = new URL(this.twikey.form.apiUrl);
				const host = (url.hostname || '').toLowerCase();
				const isTwikeyHost = host.endsWith('.twikey.com');
				const subdomain = host.split('.')[0];
				return isTwikeyHost && !!subdomain;
			} catch (e) {
				return false;
			}
		},
		filteredGdwLegalEntities() {
			// If a legal entity is selected in the top-right, only show that one
			if (this.selectedLegalEntityStore) {
				return this.localLegalEntities.filter(le => le.reference === this.selectedLegalEntityStore);
			}
			// Otherwise show all legal entities
			return this.localLegalEntities;
		},
		filteredTwikeyLegalEntities() {
			if (this.selectedLegalEntityStore) {
				return this.localLegalEntities.filter(le => le.reference === this.selectedLegalEntityStore);
			}
			return this.localLegalEntities;
		}
	},
	watch: {
		'gdw.form.legalEntity'(newValue, oldValue) {
			// Load credentials when legal entity changes (and it's not the initial load)
			if (newValue && oldValue !== undefined) {
				this.loadGdwCredentials();
			}
		},
		'twikey.form.legalEntity'(newValue, oldValue) {
			if (newValue && oldValue !== undefined) {
				this.loadTwikeyCredentials();
			}
		}
	},
	created() {
		this.$apollo
			.query({
				query: GET_PARTICIPANT_DETAILS,
				variables: {
					participant: this.selectedParticipantStore
				}
			})
			.then(({ data }) => {
				this.participantName = data.participant[0].name;
				this.localLegalEntities = data.participant[0].legal_entities;

				// If a legal entity is selected in the top-right, use that
				if (this.selectedLegalEntityStore) {
					this.gdw.form.legalEntity = this.selectedLegalEntityStore;
					this.loadGdwCredentials();
				} else if (this.localLegalEntities.length === 1) {
					// Otherwise, auto-select if there's only one legal entity
					this.gdw.form.legalEntity = this.localLegalEntities[0].reference;
					this.loadGdwCredentials();
				}

				if (this.selectedLegalEntityStore) {
					this.twikey.form.legalEntity = this.selectedLegalEntityStore;
					this.loadTwikeyCredentials();
				} else if (this.localLegalEntities.length === 1) {
					this.twikey.form.legalEntity = this.localLegalEntities[0].reference;
					this.loadTwikeyCredentials();
				}
			});
	},
	methods: {
		async loadGdwCredentials() {
			// Only load if user has permission to view
			if (!this.hasGdwGetTokenPermission) {
				return;
			}

			// Wait for legal entity to be set (either auto-selected or from backend)
			if (!this.gdw.form.legalEntity) {
				return;
			}

			this.gdw.loadingCredentials = true;
			try {
				const result = await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/gdw-dwb/get-token`, {
					'participant': this.selectedParticipantStore,
					'legal_entity': this.gdw.form.legalEntity
				}, {
					headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
				});
				if (result.data) {
					if (result.data.external_system_identifier) this.gdw.form.partyId = result.data.external_system_identifier;
					if (result.data.token) this.gdw.form.token = result.data.token;
					if (result.data.legal_entity) this.gdw.form.legalEntity = result.data.legal_entity;
				}
			} catch (e) {
				// Silently fail if credentials don't exist yet
				console.log('No GDW credentials found or error loading:', e);
			} finally {
				this.gdw.loadingCredentials = false;
			}
		},
		async connectExact() {
			this.exact.loading = true;
			try {
				let result = await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/exact-online/v1/connect`, {
					'client_id': this.exact.form.clientId,
					'client_secret': this.exact.form.custom ? this.exact.form.clientSecret : null,
					'webhook_secret': this.exact.form.custom ? this.exact.form.webhookSecret : null,
					'redirect_uri': this.exact.form.custom ? this.exact.form.redirectUri : null,
					'participant': this.selectedParticipantStore,
					'legal_entity': this.exact.form.legalEntity
				}, {
					headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
				});
				window.open(result.data.exact_connect_url, '_blank');
			} catch (e) {
				Message.error(i18n.t('somethingWentWrong2', {cause: e}));
			} finally {
				this.exact.loading = false;
			}
		},
		async connectPonto() {
			this.ponto.loading = true;
			try {
				window.open(`https://${process.env.VUE_APP_API_ENDPOINT}/psd2/ibanity/ponto-connect/connect?legal_entity=${this.ponto.form.legalEntity}`, '_blank');
			} catch (e) {
				Message.error(i18n.t('somethingWentWrong2', {cause: e}));
			} finally {
				this.ponto.loading = false;
			}
		},
		async connectTeamleader() {
			this.teamleader.loading = true;
			try {
				throw new Error('NotYetImplemented');
			} catch (e) {
				Message.error(i18n.t('somethingWentWrong2', {cause: e}));
			} finally {
				this.teamleader.loading = false;
			}
		},
		async connectOctopus() {
			this.octopus.loading = true;
			try {
				throw new Error('NotYetImplemented');
			} catch (e) {
				Message.error(i18n.t('somethingWentWrong2', {cause: e}));
			} finally {
				this.octopus.loading = false;
			}
		},
		async loadTwikeyCredentials() {
			if (!this.hasTwikeyGetApiKeyPermission) {
				return;
			}
			if (!this.twikey.form.legalEntity) {
				return;
			}
			this.twikey.loadingCredentials = true;
			try {
				const result = await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/twikey/get-api-key`, {
					'participant': this.selectedParticipantStore,
					'legal_entity': this.twikey.form.legalEntity
				}, {
					headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
				});
				if (result.data) {
					if (result.data.api_url) this.twikey.form.apiUrl = result.data.api_url;
					if (result.data.api_key) this.twikey.form.apiKey = result.data.api_key;
				}
			} catch (e) {
				// Silently fail if credentials don't exist yet
				console.log('No Twikey credentials found or error loading:', e);
			} finally {
				this.twikey.loadingCredentials = false;
			}
		},
		async saveTwikey() {
			if (!this.hasTwikeySaveApiKeyPermission) {
				return;
			}
			if (!this.isTwikeyApiUrlValid) {
				this.twikey.status = {
					type: 'error',
					message: i18n.t('integrations.invalid_twikey_api_url')
				};
				return;
			}
			this.twikey.loading = true;
			this.twikey.status = null;
			try {
				await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/twikey/save-api-key`, {
					'participant': this.selectedParticipantStore,
					'legal_entity': this.twikey.form.legalEntity,
					'api_url': this.twikey.form.apiUrl,
					'api_key': this.twikey.form.apiKey
				}, {
					headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
				});
				this.twikey.status = {
					type: 'success',
					message: i18n.t('integrations.twikey_saved')
				};
			} catch (e) {
				const errorMessage = e.response?.data?.message || e.message || i18n.t('somethingWentWrong2', {cause: e});
				this.twikey.status = {
					type: 'error',
					message: errorMessage
				};
			} finally {
				this.twikey.loading = false;
			}
		},
		async saveGdw() {
			this.gdw.loading = true;
			this.gdw.status = null; // Clear previous status
			try {
				await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/gdw-dwb/save-token`, {
					'participant': this.selectedParticipantStore,
					'legal_entity': this.gdw.form.legalEntity,
					'party_id': this.gdw.form.partyId,
					'token': this.gdw.form.token
				}, {
					headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
				});
				this.gdw.status = {
					type: 'success',
					message: i18n.t('integrations.gdw_saved')
				};
			} catch (e) {
				const errorMessage = e.response?.data?.message || e.message || i18n.t('somethingWentWrong2', {cause: e});
				this.gdw.status = {
					type: 'error',
					message: errorMessage
				};
			} finally {
				this.gdw.loading = false;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.is-error ::v-deep .el-input__inner {
	border-color: #F56C6C;
}
.is-error ::v-deep .el-input__inner:focus {
	border-color: #F56C6C;
}
</style>
